export const initialState = {
    loading: false,
    sku:{},
    skus: [],
    response: { message: null, error: null },
}